import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/facebook_logo.svg'
import _imports_1 from '@/assets/img/google_logo.svg'
import _imports_2 from '@/assets/img/apple_logo.svg'


const _hoisted_1 = { class: "socialContainer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"padding":"16px 11px"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      type: "button",
      class: "social",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signIn(_ctx.facebook, 'facebook', _ctx.facebookClass)))
    }, [
      _hoisted_2,
      _createVNode(_component_localized_text, {
        localizedKey: 'app_facebook',
        text: 'Facebook'
      })
    ]),
    _createVNode("button", {
      type: "button",
      class: "social",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signIn(_ctx.google, 'google', _ctx.googleClass)))
    }, [
      _hoisted_3,
      _createVNode(_component_localized_text, {
        localizedKey: 'app_google',
        text: 'Google'
      })
    ]),
    (_ctx.ios)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          type: "button",
          class: "appleLogin",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signIn(_ctx.apple, 'apple' , _ctx.oauthClass)))
        }, [
          _hoisted_4,
          _createVNode(_component_localized_text, {
            localizedKey: 'app_loginConApple',
            text: 'Login con Apple'
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}